export default __webpack_public_path__ + "6d58ae198eb592006cf068a380c9e161.svg";